<div class="lt-ar" #arEl [class.is-open]="open">
  <button
    type="button"
    class="lt-ar-btn"
    [class.is-on]="enabled"
    [class.is-open]="open"
    (click)="toggleMenu($event)"
    aria-haspopup="menu"
    [attr.aria-expanded]="open"
    [attr.aria-label]="'Auto-refresh: ' + valueLabel"
    id="AutoRefreshButton"
  >
    <svg class="lt-ar-icon" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
      <path fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" d="M3 6.4A5.6 5.6 0 1 1 2.4 9"/>
      <path fill="currentColor" d="M1.4 3.1l.7 3.3 3.2-.9z"/>
      <path fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" d="M8 5.3V8.2l2 1.3"/>
    </svg>
    <span class="lt-ar-prefix">Auto-refresh:</span>
    <span class="lt-ar-value" #valueEl>{{ valueLabel }}</span>
    <svg class="lt-ar-chevron" #chevronEl viewBox="0 0 10 6" width="9" height="6" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M1 1.5 5 5 9 1.5"/></svg>
  </button>

  @if (open) {
    <div class="lt-ar-menu" [style.left.px]="menuLeft" [style.width.px]="menuWidth" [style.--lt-ar-pad-right]="menuPadRight + 'px'" (clickOutside)="closeMenu()" role="menu">
      <button type="button" class="lt-ar-item" [class.is-selected]="!enabled" (click)="select(0)" role="menuitemradio" [attr.aria-checked]="!enabled">
        <span class="lt-ar-label">Off</span>
        <span class="lt-ar-tick" aria-hidden="true">
          @if (!enabled) {
            <svg viewBox="0 0 12 12" width="11" height="11"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2 6.3 4.6 9 10 3"/></svg>
          }
        </span>
      </button>
      @for (interval of intervals; track interval.seconds) {
        <button type="button" class="lt-ar-item" [class.is-selected]="isSelected(interval.seconds)" (click)="select(interval.seconds)" role="menuitemradio" [attr.aria-checked]="isSelected(interval.seconds)">
          <span class="lt-ar-label">{{ interval.label }}</span>
          <span class="lt-ar-tick" aria-hidden="true">
            @if (isSelected(interval.seconds)) {
              <svg viewBox="0 0 12 12" width="11" height="11"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2 6.3 4.6 9 10 3"/></svg>
            }
          </span>
        </button>
      }
    </div>
  }
</div>
